export const isBoolean = (value) => typeof value === 'boolean'

export const isFunction = (value) => typeof value === 'function'

export const isNumber = (value) => typeof value === 'number'

export const isNumeric = (value) => isNumber(value) || (!Number.isNaN(value) && !Number.isNaN(Number.parseFloat(value)))

export const isInteger = (value) => isNumber(value) && Number.isInteger(value)

export const isNotNumeric = (value) => !isNumeric(value)

export const isString = (value) => typeof value === 'string'

export const isArray = (value) => Array.isArray(value)

export const isObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value)

export const isPromise = (value) => isObject(value) && isFunction(value.then)

export const isDate = (value) => value instanceof Date

export const isTrue = (value) => isBoolean(value) && value === true

export const isFalse = (value) => isBoolean(value) && value === false

export const isJson = (value) => {
  if (!isString(value) || isEmpty(value)) return false
  try {
    JSON.parse(value)
  } catch (e) {
    return false
  }
  return true
}

export function isEmpty(value) {
  let empty = false
  if (value === null || value === undefined) empty = true
  else if (isString(value) && value === '') empty = true
  else if ((isArray(value) || isString(value)) && value.length < 1) empty = true
  else if (isString(value) && !/\S/.test(value)) empty = true
  else if (isObject(value) && Object.keys(value).length < 1) empty = true
  return empty
}

export function isNotEmpty(value) {
  return !isEmpty(value)
}

// https://stackoverflow.com/questions/4565112/javascript-how-to-find-out-if-the-user-browser-is-chrome
const hasWindow = typeof window !== 'undefined'
const hasNavigator = typeof navigator !== 'undefined'
const hasDocument = typeof document !== 'undefined'

export const isUsingBrowser = (browser) => {
  if (!hasNavigator) return false
  return navigator.userAgent.toLowerCase().indexOf(browser.toLowerCase()) > -1
}

// browsers
export const isFirefox = isUsingBrowser('firefox')
export const isChromeBrowser = isUsingBrowser('chrome')
export const isChrome = hasNavigator && /Google Inc/.test(navigator.vendor)
export const isChromeIosBrowser = isUsingBrowser('CriOS')
export const isEdgeBrowser = isUsingBrowser('edge')
export const isCordova = hasWindow && !!window.cordova
export const isIEBrowser = isUsingBrowser('trident')
export const isOperaBrowser = isUsingBrowser('opr')
export const isSafari = isUsingBrowser('safari')

// helpers
export const isTouchScreen = (hasWindow && 'ontouchstart' in window) || (hasWindow && window.DocumentTouch)
export const isWebComponentsSupported =
  hasDocument &&
  'registerElement' in document &&
  'import' in document.createElement('link') &&
  'content' in document.createElement('template')

export const isBase64 = (url) => !!url?.match(/^data:image/)
export const isNormalImg = (url) => !!url?.match(/\.(jpg|jpeg|png|gif|tif|tiff|svg|bmp)$/)

export const isTouchDevice = () => {
  let hasTouchScreen
  if ('maxTouchPoints' in window.navigator) {
    hasTouchScreen = window.navigator.maxTouchPoints > 0
  } else if ('msMaxTouchPoints' in window.navigator) {
    hasTouchScreen = window.navigator.msMaxTouchPoints > 0
  } else {
    const mQ = window.matchMedia && matchMedia('(pointer:coarse)')
    if (mQ && mQ.media === '(pointer:coarse)') {
      hasTouchScreen = Boolean(mQ.matches)
    } else if ('orientation' in window) {
      hasTouchScreen = true // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing
      const UA = window.navigator.userAgent
      hasTouchScreen =
        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
    }
  }
  return hasTouchScreen
}

export const isMobile = {
  Android: () => navigator.userAgent.toLowerCase().includes('android'),
  BlackBerry: () => navigator.userAgent.toLowerCase().includes('blackberry'),
  iOS: () => {
    const ua = navigator.userAgent.toLowerCase()
    return ua.includes('iphone') || ua.includes('ipad') || ua.includes('ipod')
  },
  Opera: () => navigator.userAgent.toLowerCase().includes('opera mini'),
  Windows: () => {
    const ua = navigator.userAgent.toLowerCase()
    return ua.includes('iemobile') || ua.includes('wpdesktop')
  },
  any() {
    return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows()
  },
}
